var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue } from 'vue-property-decorator';
import * as yup from 'yup';
var KaskoCalculatorValidationMixin = /** @class */ (function (_super) {
    __extends(KaskoCalculatorValidationMixin, _super);
    function KaskoCalculatorValidationMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KaskoCalculatorValidationMixin.prototype, "step1ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step1) || {};
            return yup.object().shape({
                brand: yup
                    .string()
                    .required(t.brand_required || 'Marka seçilməlidir'),
                year: yup
                    .string()
                    .required(t.year_required || 'Buraxılış ili seçilməlidir'),
                marketValue: yup
                    .string()
                    .required(t.market_value_required || 'Qiymət tələb olunur')
                    .test('is-valid-amount', t.market_value_invalid || 'Qiymət düzgün deyil', function (value) {
                    if (!value)
                        return true;
                    var amount = parseFloat(value);
                    return amount > 0;
                }),
                officialService: yup
                    .string()
                    .required(t.official_service_required || 'Rəsmi servis seçilməlidir'),
                driver: yup
                    .string()
                    .required(t.driver_required || 'Sürücü seçilməlidir'),
                franchise: yup
                    .string()
                    .required(t.franchise_required || 'Franşiza seçilməlidir')
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(KaskoCalculatorValidationMixin.prototype, "step2ValidationSchema", {
        get: function () {
            var _a;
            var t = ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.step2) || {};
            return yup.object().shape({
                firstName: yup
                    .string()
                    .required(t.first_name_required || 'Ad tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.first_name_invalid || 'Ad yalnız hərflərdən ibarət olmalıdır')
                    .max(30, t.first_name_max || 'Ad maksimum 30 simvol ola bilər'),
                lastName: yup
                    .string()
                    .required(t.last_name_required || 'Soyad tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.last_name_invalid || 'Soyad yalnız hərflərdən ibarət olmalıdır')
                    .max(30, t.last_name_max || 'Soyad maksimum 30 simvol ola bilər'),
                fatherName: yup
                    .string()
                    .required(t.father_name_required || 'Ata adı tələb olunur')
                    .matches(/^[A-Za-zƏəİıÖöÜüĞğŞşÇç\s]+$/, t.father_name_invalid || 'Ata adı yalnız hərflərdət ibarət olmalıdır')
                    .max(30, t.father_name_max || 'Ata adı maksimum 30 simvol ola bilər'),
                fin: yup
                    .string()
                    .required(t.fin_required || 'FIN kod tələb olunur')
                    .length(7, t.fin_invalid || 'FIN kod 7 simvoldan ibarət olmalıdır'),
                phone: yup
                    .string()
                    .required(t.phone_required || 'Telefon nömrəsi tələb olunur')
                    .matches(/^\(\+994\) \d{2} \d{3} \d{2} \d{2}$/, t.phone_invalid || 'Telefon nömrəsi düzgün formatda deyil')
            });
        },
        enumerable: false,
        configurable: true
    });
    KaskoCalculatorValidationMixin.prototype.validateStep1 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1, errors_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Validating Step1...', this.stepsData.step1);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.step1ValidationSchema.validate(this.stepsData.step1, { abortEarly: false })];
                    case 2:
                        _a.sent();
                        this.step1Errors = {};
                        console.log('Step1 validation passed');
                        return [2 /*return*/, true];
                    case 3:
                        err_1 = _a.sent();
                        errors_1 = {};
                        if (err_1.inner) {
                            err_1.inner.forEach(function (error) {
                                errors_1[error.path] = error.message;
                            });
                        }
                        this.step1Errors = errors_1;
                        console.log('Step1 validation failed:', errors_1);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    KaskoCalculatorValidationMixin.prototype.validateStep2 = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_2, errors_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.log('Validating Step2...', this.stepsData.step2);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.step2ValidationSchema.validate(this.stepsData.step2, { abortEarly: false })];
                    case 2:
                        _a.sent();
                        this.step2Errors = {};
                        console.log('Step2 validation passed');
                        return [2 /*return*/, true];
                    case 3:
                        err_2 = _a.sent();
                        errors_2 = {};
                        if (err_2.inner) {
                            err_2.inner.forEach(function (error) {
                                errors_2[error.path] = error.message;
                            });
                        }
                        this.step2Errors = errors_2;
                        console.log('Step2 validation failed:', errors_2);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    KaskoCalculatorValidationMixin.prototype.validateCurrentStep = function (currentStep) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(currentStep === 1)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validateStep1()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        if (!(currentStep === 2)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.validateStep2()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4: return [2 /*return*/, true];
                }
            });
        });
    };
    KaskoCalculatorValidationMixin = __decorate([
        Component
    ], KaskoCalculatorValidationMixin);
    return KaskoCalculatorValidationMixin;
}(Vue));
export default KaskoCalculatorValidationMixin;
